import React from 'react'
import { trimValues } from 'lib/helpers/forms'
import { toBooleanOrNull } from "lib/helpers/parent/forms"

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      updateEmergencyContact, // via withMutation
      form: reduxForm, // via withRedux
      emergencyContact // via withQuery
    } = props

    const form = trimValues(reduxForm)

    // perform GraphQL mutation
    const handleSubmit = e => {
      e.preventDefault()

      updateEmergencyContact({
        variables: {
          emergencyContactId: emergencyContact.id,
          input: {
            firstName: form.firstName,
            lastName: form.lastName,
            relationshipToCampers: form.relationshipToCampers,
            legalGuardian: toBooleanOrNull(form.legalGuardian),
            primaryPhone: form.primaryPhone,
            alternatePhone: form.alternatePhone,
            pickup: ['true', true].includes(form.pickup)
          }
        }
      })
    }

    return <WrappedComponent handleSubmit={handleSubmit} {...props} />
  }
}

export default withEventHandlers
